import React, { } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockStatisticModel } from "../stockStatisticModel";
import useNavModel from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { descTotal, selectedRowKeys, rowsDescTotal, statistics, exportStockStatistic, setRelocationVisible, setRecordsVisible } = useStockStatisticModel();
    const desc: IDescription[] = [
        {
            label: "库存数量",
            value: statistics?.stockNum ?? 0,
            color: DescriptionColorEnum.red
        },
        // {
        //     label: "库存种类",
        //     value: selectedRowKeys.length === 0 ? descTotal.type : rowsDescTotal.type,    // "33.233",
        //     color: DescriptionColorEnum.red
        // },
        // {
        //     label: " 库存成本（最近）",
        //     value: selectedRowKeys.length === 0 ? descTotal.latestAmountTotal : rowsDescTotal.latestAmountTotal,  // "33.233",
        //     color: DescriptionColorEnum.red
        // },
        // {
        //     label: " 库存成本（平均）",
        //     value: selectedRowKeys.length === 0 ? descTotal.averageAmount : rowsDescTotal.averageAmount,    // "33.233",
        //     color: DescriptionColorEnum.red
        // }
    ]

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.ST_INVENT_EX}>
            {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
            <Button
                // disabled={true}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportStockStatistic().then()}
            >导出</Button>
            {/* </Tooltip> */}
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => setRelocationVisible(true)}
        >移库</Button> */}
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => setRecordsVisible(true)}
        >转移记录</Button> */}
    </>;

    return (
        // <YhBox title="库存统计列表" descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 200px)' }}>
            <DataTable />
        </YhBox>
    )
}